var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{key:_vm.inputType,ref:"input",attrs:{"size":_vm.size,"value":_vm.value,"placeholder":_vm.placeholder,"type":_vm.inputType},on:{"input":_vm.handleInput}},[(_vm.value)?_c('svg-icon',{attrs:{"slot":"suffix","iconClass":_vm.iconClass,"class-name":"switch-icon"},on:{"click":_vm.handleIconClick},slot:"suffix"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }